<template>
  <div class="news-column">
    <home-news-panel v-for="item in articles" :key="'news' + item.news_id" :item="item" />
  </div>
</template>

<script>
import ViewablePanel from '@/mixins/ViewablePanel.js'
import HomeNewsPanel from './HomeNewsPanel.vue'

export default {
  components: {
    HomeNewsPanel
  },
  props: {
    tag: String
  },
  mixins: [ViewablePanel],
  data () {
    return {
      articles: []
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      if(!this.tag) return
      this.articles = []
      let res = await this.$apix.get(this.$k.getNewsUrl('news/bytag/' + this.tag + '/'))
      this.articles = res.data.slice(0,3)
    }
  },
  watch: {
    tag () {
      if(this.tag) {
        if(this.seen){
          this.init()
        }
      }
    },
    seen() {
      if(this.seen) {
        this.init()
      }
    }
  }
}
</script>

<style scoped>
.news-column{
  display:flex;
  flex-direction:column;
  flex-grow:1;
  
}




</style>